import { postAPI , getAPI } from "../../api";
import { REACT_APP_TIMESHEET } from "../../utils/common";

export async function getTimesheetListforcustomer(searchValue : string , page : number, pageSize: number, data?: any){ 
    const Details = postAPI( REACT_APP_TIMESHEET + `/contract-timesheet?search=${searchValue}&page=${page}&size=${pageSize}`,data)
    return Details
}

export async function getHistory(timesheetId: string) {
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-status-history/${timesheetId}`)
    return Details
}




